import {KeyConstant} from "../constant/keyConstant";
import moment from "moment";

export const mapStartDatePeriod = (type, startDate , endDate) =>{

    let dateDiff = moment(endDate).diff(moment(startDate), 'days') + 1

    switch (type){
        case KeyConstant.TODAY:
        case KeyConstant.YESTERDAY:
            return moment(startDate).subtract(1, "days").format("DD/MM/YYYY")
        case KeyConstant.THIS_WEEK:
        case KeyConstant.LAST_WEEK:
            return moment(startDate).subtract(1, "weeks").format("DD/MM/YYYY")
        case KeyConstant.THIS_MONTH:
        case KeyConstant.LAST_MONTH:
            return moment(startDate).subtract(1, "months").format("DD/MM/YYYY")
        case KeyConstant.SEVEN_DAYS_AGO:
            return moment(startDate).subtract(7, "days").format("DD/MM/YYYY")
        case KeyConstant.THIRTY_DAYS_AGO:
            return moment(startDate).subtract(30, "days").format("DD/MM/YYYY")
        case KeyConstant.NINETY_DAYS_AGO:
            return moment(startDate).subtract(90, "days").format("DD/MM/YYYY")
        default :
            return moment(startDate).subtract(dateDiff, "days").format("DD/MM/YYYY")
    }
}
